/* istanbul ignore file */
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    detection: { order: ['navigator'] },
    interpolation: {
      escapeValue: false,
    },
    load: 'all',
  });

export default i18n;
